









































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { TicketModule } from '@/store/modules/ticket'
import isEqual from 'lodash/isEqual'
import AperGr from '@/components/Groups/AperGr.vue'
import Alert from '@/components/Alert.vue'
import { tooltipTailleCopro } from '@/data/tooltips'
import { formatBigInteger } from '@/filters/numbers'
import Project from '@/views/profile/Project.vue'
import Plan from '@/components/Dashboard/Plan.vue'
import { ApiService } from '@/api/api.service'
import { UserModule } from '@/store/modules/user'
import { getOperationID } from '@/api/operations'
import { NotificationsModule } from '@/store/modules/notifications'

@Component({
    filters: {
        formatBigInteger,
        formatExposure(value: 'south' | 'north' | 'west' | 'east'): string {
            switch (value) {
                case 'south':
                    return 'sud'
                case 'north':
                    return 'nord'
                case 'west':
                    return 'ouest'
                case 'east':
                    return 'est'
            }
        },
        formatFloor(
            value: 'ground' | 'first' | 'intermediate' | 'top'
        ): string {
            switch (value) {
                case 'ground':
                    return 'au rez-de-chaussée'
                case 'first':
                    return 'au 1er étage'
                case 'intermediate':
                    return 'à un étage intermédiaire'
                case 'top':
                    return 'à un étage élevé'
            }
        },
        formatOutdoorSize(value: 'Aucun' | number): string {
            if (!isNaN(value as number)) {
                return `${value}m²`
            } else {
                return 'aucun'
            }
        },
        formatParkingSize(value: 0 | 1 | 2): string {
            switch (value) {
                case 0:
                    return 'aucun'
                case 1:
                    return 'une place'
                case 2:
                    return 'deux places'
            }
        },
        formatParkingBoxed(value): string {
            let res = value.boxed ? 'boxée' : 'non boxée'

            if (value.size > 1) {
                res += 's'
            }
            return res
        },
    },
    components: {
        AperGr,
        Alert,
        Project,
        Plan,
    },
})
export default class Ticket extends Vue {
    apiService = new ApiService()
    get planRequested() {
        return TicketModule.planRequested || this.localPlanRequested
    }

    localPlanRequested: boolean = false
    requestPlanLoading: boolean = false
    requestPlanError: string = null
    // Phase 1 — État 3 : validation du plan reçu
    planConfirmed: boolean = false
    validateLoading: boolean = false
    validateError: string = null

    tooltips = {
        total: `
            <div>
                Le prix affiché correspond à une estimation réalisée sur la base des préférences et options que vous avez sélectionnées.
            </div>
            <div>
                Il s'agit d'un montant provisoire qui ne constitue pas une offre contractuelle.
                Le prix définitif de votre bien sera établi après validation finale du plan, des prestations retenues et des éventuels ajustements, et sera confirmé dans le contrat de réservation (à la fin de l'Étape 4 - Personnalisation)
            </div>
        `,
        validatePlan: `
            <div>
                En validant votre projet, vous transmettez votre demande à l'architecte.
                Après analyse de votre configuration, un Plan Générique vous sera adressé dans un délai de 1 mois.
            </div>
        `,
        salePrice: `
            <div>
                Il s'agit d'un montant provisoire qui ne constitue pas une offre contractuelle.
                Le prix de votre bien sera définitif après la personnalisation et sera confirmé dans le contrat de réservation.
            </div>
        `,
    }

    get ticketData() {
        return TicketModule.ticketData
    }

    get phase() {
        return TicketModule.phase
    }

    get planPdfUrl() {
        return TicketModule.planPdfUrl
    }

    get integratedPlanUrl() {
        return TicketModule.integratedPlanUrl
    }

    get hasPersonalizedPlan() {
        return TicketModule.planPdfUrl !== null
    }

    get sketches() {
        return TicketModule.sketches
    }

    get salePrice() {
        return TicketModule.salePrice
    }

    async created() {
        await TicketModule.refresh()
    }

    @Watch('ticketData')
    async onTicketData(val, oldVal) {
        await this.$nextTick()

        if (oldVal && !isEqual(val, oldVal)) {
            this.animateCSS(this.$refs.ticket as HTMLElement, 'bounceIn')
        }
        requestAnimationFrame(() => {
            const $popoverDismiss = $('.popover-dismiss') as any
            $popoverDismiss.popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }

    animateCSS(
        node: HTMLElement,
        animationName: string,
        callback: Function | null = null
    ) {
        node.classList.add('animated', animationName)
        const handleAnimationEnd = () => {
            node.classList.remove('animated', animationName)
            node.removeEventListener('animationend', handleAnimationEnd)

            if (typeof callback === 'function') callback()
        }
        node.addEventListener('animationend', handleAnimationEnd)
    }

    mounted() {
        const $aperGrpModal = $(this.$refs.aperGrpModal) as any
        $aperGrpModal.on('hidden.bs.modal', this.onModalHidden)
    }

    destroyed() {
        const $aperGrpModal = $(this.$refs.aperGrpModal) as any
        $aperGrpModal.off('hidden.bs.modal', this.onModalHidden)
    }

    onModalHidden() {
        console.log('modalHidden')
        this.selectedGroupID = null
    }

    selectedGroupID: number = null
    showGrp(sharedSpace) {
        this.selectedGroupID = sharedSpace.id
    }

    showModal() {
        const $aperGrpModal = $(this.$refs.aperGrpModal) as any
        $aperGrpModal.modal('show')
    }

    showAlert(obj) {
        if (obj.type === 'success') {
            ;(<any>$(this.$refs.groupModal)).modal('hide')
            ;(<any>$(this.$refs.aperGrpModal)).modal('hide')
        }
        ;(<Alert>this.$refs.alert).handleAlert(obj.type, obj.message)
    }

    onQuitGroup(groupID) {
        TicketModule.refresh()
    }

    get tooltipTailleCopro() {
        return tooltipTailleCopro
    }

    priceValidated: boolean = false
    priceValidateLoading: boolean = false
    priceValidateError: string = null

    async validatePrice() {
        this.priceValidateLoading = true
        this.priceValidateError = null
        try {
            const opeId = await getOperationID()
            await this.apiService.postValidatePrice(UserModule.userInfos.id, opeId)
            this.priceValidated = true
            NotificationsModule.ForceRefreshNotifications()
            await TicketModule.refresh()
            TicketModule.setPhase(4)
        } catch (e) {
            this.priceValidateError = 'Une erreur est survenue. Veuillez réessayer.'
        } finally {
            this.priceValidateLoading = false
        }
    }

    async requestPlan() {
        this.requestPlanLoading = true
        this.requestPlanError = null
        try {
            const opeId = await getOperationID()
            await this.apiService.postRequestPlan(UserModule.userInfos.id, opeId)
            this.localPlanRequested = true
            NotificationsModule.ForceRefreshNotifications()
            const u = UserModule.userInfos
            const fullName = `${u.firstname} ${u.lastname}`.trim()
            this.apiService.postAdminNotification({
                type: 'reservation',
                message: `${fullName} a effectué une demande de plan à l'étape 1.`.substring(0, 255),
                context: { user_id: u.id, operation_id: opeId },
            }).catch(() => { /* silent */ })
        } catch (e) {
            this.requestPlanError = 'Une erreur est survenue. Veuillez réessayer.'
        } finally {
            this.requestPlanLoading = false
        }
    }

    async validatePlan() {
        this.validateLoading = true
        this.validateError = null
        try {
            const opeId = await getOperationID()
            await this.apiService.postValidatePlan(UserModule.userInfos.id, opeId)
            this.planConfirmed = true
            NotificationsModule.ForceRefreshNotifications()
            await TicketModule.refresh()
            TicketModule.setPhase(2)
        } catch (e) {
            this.validateError = 'Une erreur est survenue. Veuillez réessayer.'
        } finally {
            this.validateLoading = false
        }
    }

    showPlanPhase1Modal() {
        const $modal = $(this.$refs.planPhase1Modal) as any
        $modal.modal('show')
    }

    showPlanPhase4Modal() {
        const $modal = $(this.$refs.planPhase4Modal) as any
        $modal.modal('show')
    }

    handlePlanAlert(level, msg) {
        ;(<Alert>this.$refs.alert).handleAlert(level, msg)
    }

    async showPriceListModal() {
        const $project = this.$refs.project as Project
        await $project.resresh()

        const $modal = $(this.$refs.modal) as any
        $modal.modal('show')
    }

    onPriceListModalClose() {
        const $modal = $(this.$refs.modal) as any
        $modal.modal('hide')
    }
}
